export class LocationModel {
  id: string
  title: string
  description: string
  image_url: string
  constructor(obj: any = null) {
    this.id = obj?.id
    this.title = obj?.title
    this.description = obj?.description
    this.image_url = obj?.image_url
  }
}
